import React, {Component} from 'react';
import './styles/Image.css';

class Image extends Component {
    render() {
        let style = {
            backgroundImage: `url(${this.props.src})`
        };

        if (this.props.aspectRatio) {
            const proportions = this.props.aspectRatio.split(':');
            style.paddingTop = `${100 / proportions[0] * proportions[1]}%`;
        }

        if (this.props.position) {
            style.backgroundPosition = this.props.position;
        }

        return (
            <div
                className={`image 
                ${this.props.className ? this.props.className : ''} 
                ${this.props.cover ? 'image--cover' : ''}  
                ${this.props.contain ? 'image--contain' : ''} 
                ${this.props.shadow ? 'image--shadow' : ''}`}
                style={style}/>
        );
    }
}

export default Image;